import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import Header from './Header';
import UrlInput from './UrlInput';
import SwfFileList from './SwfFileList';
import axios from 'axios';
import ByURL from './ByURL';
import ByFileName from './ByFileName';
import { Switch, Route, Link } from 'react-router-dom'
import MyNav from './MyNav';
import Intro from './Intro';
import FlatButton from 'material-ui/FlatButton/FlatButton';

const Info = () => {
  return (
    <div className="App">
      <p>This app is intended to help users view flash video (swf) files with Chrome browsers. </p>
        <p>Please make sure to allow flash on your browser before proceeding!</p>
      <p><a href="https://support.google.com/chrome/answer/6258784?co=GENIE.Platform%3DDesktop&hl=en">How to enable flash?</a></p>
    </div>
  )
}

class App extends Component {
  constructor(props){
    super(props);
    this.state = {
      url_id: '',
      fileList: null,
      url_error: false
    };
  }
  render() {
    return (
      <div className="App">
      <MyNav/>
      <Link to="/">
        <FlatButton label="Home" primary={true}/>
      </Link>      
      <Link to="/Intro">
        <FlatButton label="Introduction" primary={true}/>
      </Link>
      <Link to="/ByURL">
        <FlatButton label="View Multiple" primary={true}/>
      </Link>      
      <Link to="/ByFileName">
        <FlatButton label="View Single" primary={true}/>
      </Link>            
      <Switch>
      <Route path="/Intro" render={(props)=> (
        <Intro/>
        )}/>        
      <Route path="/ByURL" render={(props)=> (
        <div>
        <Info/>
        <ByURL {...this.state} {...props}/>
        </div>
        )}/>
      <Route path="/ByFileName" render={(props)=> (
        <div>
          <Info/>
        <ByFileName {...this.state} {...props}/>
        </div>
        )}/>
      </Switch>
      <Footer/>
      </div>
    );
  }

}
const Footer = () =>{
  return(
    <div>
    <h4>An app by friends at <a href="https://www.Dynos.io">Dynos.io</a></h4>
    </div>
  )
}
export default App;



// WEBPACK FOOTER //
// ./src/App.js